import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/navbar.component";
import Footer from "../components/footer.component";

const VideoInterview = () => {
  const HEIGHT = 440;
  const WIDTH = 600;
  const videoRef = useRef(null);
  const streamRef = useRef(null);
  const [isStreaming, setIsStreaming] = useState(false);
  const [streamError, setStreamError] = useState("");

  const clearStream = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
      streamRef.current = null;
    }

    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
  };

  const startVideo = async () => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      setStreamError("Your browser does not support camera access.");
      return;
    }

    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
      streamRef.current = mediaStream;

      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;
      }

      setStreamError("");
      setIsStreaming(true);
    } catch (error) {
      setStreamError("Unable to access camera. Please allow permissions and try again.");
      setIsStreaming(false);
    }
  };

  const stopVideo = () => {
    clearStream();
    setIsStreaming(false);
  };

  useEffect(() => {
    return () => {
      clearStream();
    };
  }, []);

  return (
    <>
    <Navbar/>
      <div className="d-flex flex-column align-items-center px-52 " style={{marginBottom:"30px"}}>
        <h1 className="display-2 font-link font-weight-bold mb-16" style={{fontWeight:"bolder",marginTop:"20px",marginBottom:"15px"}}>
          video interview .
        </h1>

        <div className="w-full h-full d-flex " style={{gap:120 ,}}>
          <div className="w-full h-full " style={{marginLeft:"100px"}}>

            <div className="app">
              <div className="app__container bg-dark p-2" style={{height:"440px", width:"600px", marginBottom:"20px"  }}>
                <video
                  ref={videoRef}
                  height={HEIGHT}
                  width={WIDTH}
                  muted
                  autoPlay
                  className="app__videoFeed"
                  style={{paddingRight:"300px", paddingBottom:"20px"}}
                ></video>
              </div>
              <div className="app__input ">

                {isStreaming ? (
                  <button
                    type="button"
                    className="border-2 px-3 text-blue border-black fs-4 font-medium rounded-2"
                    onClick={stopVideo}
                    style={{ marginTop: "20px", marginBottom: "20px" }}
                  >
                    Stop Camera
                  </button>
                ) : (
                  <button
                    type="button"
                    className="border-2 px-3 text-blue border-black fs-4 font-medium rounded-2"
                    onClick={startVideo}
                    style={{ marginTop: "20px", marginBottom: "20px" }}
                  >
                    Start Camera
                  </button>
                )}

                {streamError ? (
                  <div className="text-danger" style={{ maxWidth: "600px", marginBottom: "10px" }}>
                    {streamError}
                  </div>
                ) : null}

              </div>
            </div>

          </div>

        <div className="d-flex flex-column gap-4 ml-12 text-xl font-regular"style={{marginTop:"30px" , height:"100%"}}>
            <div className="w-full rounded-2 fs-4 p-2 ml-4" style={{backgroundColor:"lightgrey",height:"100px",width:"380px"}}>
              You will have 15 mins to answer the questions mentioned above.
            </div>
            <div className=" rounded-2 p-4 fs-4" style={{backgroundColor:"lightgrey",height:"310px",width:"380px"}}>
              Qus 1
              <br />
              Qus 2
              <br />
              Qus 3
              <br />
            </div>
            <div className="d-flex  justify-evenly mb-10 pt-5	">
              <Link to="/video_dash" style={{ marginTop:"-25px" }}>
                <button type="button" className="border-2  px-3 text-blue  border-black fs-4 font-medium rounded-2">
                  Submit
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Footer/>
    </>
  );
};
export default VideoInterview;
